<template>
  <div class="page">
    <PhotoMakeHeader></PhotoMakeHeader>
    <div style="height: 10%"></div>
    <div class="title">
      <div class="title-left">
        <div class="trapezoid"></div>
        <div style="font-weight: bold;font-size: 14px;color: #35315C">我的订单</div>
      </div>
      <div @click="goMake" style="font-size: 12px;color: #aaaaaa;cursor: pointer">
        继续制作 >
      </div>
    </div>
    <div v-show="orderList.length===0" class="no-order">
      <img style="width: 15%;margin-top: 10%" src="../assets/make/public/no-mask.png">
      <div style="margin-bottom: 2%;font-size: 12px;color: rgba(53,49,92,0.5)">暂未选择规格</div>
      <div @click="goMake" class="btn">立即去制作</div>
    </div>
    <div v-show="orderList.length>0" id="box">
      <div class="list-item" :key="index" v-for="(item,index) in showList">
        <div class="list-item-title">
          <div class="list-item-title-left">
            <span style="font-size: 12px;color: #35315C;font-weight: bold">订单编号：{{item.order_id}}</span>
            <div :class="item.order_state?'pay-flag-cube-active':'pay-flag-cube'">
              {{`${item.order_state?'已付款':'未付款'}`}}
            </div>
          </div>
          <img @click="handleDeleteOrder(item.order_id)" style="width: 20px;cursor: pointer" src="../assets/make/public/order_delete.png">

        </div>
        <div class="list-item-content">
          <div :style="{backgroundImage: 'url(' + ( item.url[0]) + ')'}"  class="elc-photo"></div>
          <div v-if="item.is_print" :style="{backgroundImage: 'url(' + ( item.url_print[0]) + ')'}" class="print-photo"></div>
          <div v-if="!item.is_print" class="print-photo"></div>
          <div class="list-item-content-contain">
            <div class="list-item-content-txt">
              <div>
                <div style="font-size: 14px;font-weight: bold;line-height: 30px;color: #35315C">{{item.spec_name}}</div>
                <div style="font-size: 12px;color: rgba(53,49,92,0.4)">{{item.px_mm_text}}</div>
              </div>
              <div>
                <div style="font-size: 13px;font-weight: bold;line-height: 30px;color: #35315C">增值服务</div>
                <div style="font-size: 12px;color: rgba(53,49,92,0.4)">{{item.additionalCompositionText}}</div>
              </div>
              <div>
                <div style="font-size: 13px;font-weight: bold;line-height: 30px;color: #35315C">优惠服务</div>
                <div style="font-size: 12px;color: rgba(53,49,92,0.4)">{{item.extraText}}</div>
              </div>
              <div>
                <div style="font-size: 13px;font-weight: bold;line-height: 30px;color: #35315C">总价</div>
                <div style="font-size: 12px;color: #FF7BAC">￥{{(item.fee/100).toFixed(2)}}</div>
              </div>
            </div>
            <div class="list-item-content-btn-contain">
              <div @click="goPay(item)" v-show="!item.order_state" class="list-item-content-btn">继续支付</div>
              <div @click="handleDownload(item)" v-show="item.order_state" class="list-item-content-btn">保存到电脑</div>
              <div @click="sendEmailClick(item.order_id)" v-show="item.order_state" class="list-item-content-btn">发送到邮箱</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 10%"></div>
    <div v-show="orderList.length>0" id="pagination">
      <el-pagination
              background
              @current-change="pageChange"
              layout="prev, pager, next"
              :page-size="10"
              :total="total">
      </el-pagination>
    </div>
    <QuestionDialog></QuestionDialog>
    <PhotoMakeFooter></PhotoMakeFooter>
    <PayDialog @close="closePayDialog" :payInfo="payInfo" :show="payDialogShow" @success="getOrderList"></PayDialog>
    <SendEmailDialog @send="sendEmail" @close="closeSendEmailDialog" :show="sendEmailDialogShow"></SendEmailDialog>
  </div>
</template>

<script>
    import PhotoMakeHeader from "../components/PhotoMakeHeader";
    import PhotoMakeFooter from "../components/PhotoMakeFooter";
    import QuestionDialog from "../components/QuestionDialog";
    import PayDialog from "../components/PayDialog";
    import SendEmailDialog from "../components/SendEmailDialog";
    import api from "../makeOnlineApi/api"
    import utils from "../makeOnlineApi/utils";
    import axios from 'axios'
    import JSZip from 'jszip'
    import FileSaver from 'file-saver'
    const download = axios.create({})



    export default {
        name: "Order",
        components: {PhotoMakeHeader,PhotoMakeFooter,QuestionDialog,PayDialog,SendEmailDialog},
        computed:{
            showList(){
                let showList = this.orderList.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
                showList = showList&&showList.map(item=>{
                    let extraText= ''
                    let additionalCompositionText=item.back_number===-1?'多背景':''
                    let px_mm_text=`${item.px_size[0]} x ${item.px_size[1]}px | ${item.mm_size[0]} x ${item.mm_size[1]}mm`

                    item.url_extra?item.url_extra.forEach((extraItem,extraIndex)=>{
                        extraText+=`${extraIndex===0?'':'|'}${extraItem.name}`
                    }):extraText='无'
                    item.composition.additional_composition.length>0&&item.composition.additional_composition.forEach(additionalItem=>{
                        additionalCompositionText=`${additionalItem.exp}${item.back_number===-1?'|':''}`+additionalCompositionText

                    })
                    return{
                        ...item,
                        extraText,
                        px_mm_text,
                        additionalCompositionText:additionalCompositionText||'无'
                    }

                })
                console.log(showList)
                return showList
            },
            total(){
                return this.orderList.length
            },
        },


        data(){
            return{
                // showList:[1,2],
                orderList:[],
                currentPage:1,
                pageSize:10,
                payInfo:{},
                payDialogShow:false,
                sendEmailDialogShow:false,
                orderId:'',

            }
        },
        created() {
            this.getOrderList()
        },
        mounted() {

        },
        methods:{
            goMake(){
                this.$router.push({
                    path:'/uploadPhoto'
                })
            },
            getOrderList(){
                const loading = this.$loading({
                    lock: true,
                    text: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                api.getOrderList().then((res)=>{

                    this.orderList=res.data.order_list_final_ordered
                    console.log(this.orderList.length)
                    loading.close()
                }).catch(()=>{
                    loading.close()
                })
            },
            pageChange(page){
                console.log('currentPage',page)
                this.currentPage=page
            },
            closePayDialog(flag){
                this.payDialogShow=flag
            },
            // 继续支付
            goPay(params){
                this.payInfo={
                    pay_fee:params.fee,
                    order_id:params.order_id
                }
                this.payDialogShow=true
            },
            // 删除订单
            handleDeleteOrder(id){
                api.deleteOrder(id).then(()=>{
                    this.$message.success({
                        message:'删除成功'
                    })
                    this.getOrderList()
                })
            },

            handleDownload(item) {
                const loading = this.$loading({
                    lock: true,
                    text: '打包下载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                const list = utils.getDownloadInfoUtils(item)
                console.log('最终下载信息',list)
                const zip = new JSZip()
                const cache = {}
                const promises = []
                list.forEach((item) => {
                    const promise = this.getFile(`${item.url}&timeStamp=${(new Date()).valueOf()}`).then(data => {
                        // const arr_name = item.split('/') // 下载文件, 并存成ArrayBuffer对象
                        // const file_name = arr_name[arr_name.length - 1] // 获取文件名
                        zip.file(item.name, data, { binary: true }) // 逐个添加文件
                        cache[item.name] = data
                        console.log(cache)
                    })
                    promises.push(promise)
                })
                Promise.all(promises).then(() => {
                    zip.generateAsync({ type: 'blob' }).then(content => {
                        // 生成二进制流
                        FileSaver.saveAs(content, `${item.order_id}`) // 利用file-saver保存文件  自定义文件名
                        loading.close()
                    }).catch(()=>{
                        loading.close()
                        this.$message.error({
                            message:'下载失败，请重试'
                        })
                    })
                })
            },

             getFile (url)  {
                return new Promise((resolve, reject) => {
                    let obj = {
                        method: 'get',
                        url,
                        responseType: 'blob'
                        // responseType:'arraybuffer'
                    }
                    download(obj)
                        .then(res => {
                            resolve(res.data)
                        })
                        .catch(error => {
                            reject(error.toString())
                        })
                })
            },

            // 保存照片
            handleSavePhoto(params){


                params.url.forEach((item,index)=>{

                    utils.convertUrlToBase64(`${item}&timeStamp=${(new Date()).valueOf()}`).then(function(base64) {
                        // 图片转为base64
                        const blob = utils.convertBase64UrlToBlob(base64); // 转为blob对象
                        // 下载
                        if (utils.myBrowser() === "IE") {
                            window.navigator.msSaveBlob(blob, `${index}` + ".jpg");
                        } else if (utils.myBrowser() === "FF") {
                            window.location.href = item;
                        } else {
                            let a = document.createElement("a");
                            a.download = name;
                            a.href = URL.createObjectURL(blob);
                            a.click();
                        }
                    });
                })



            },

            closeSendEmailDialog(flag){
                this.sendEmailDialogShow=flag

            },
            sendEmailClick(orderId){
                this.orderId = orderId
                this.sendEmailDialogShow=true
            },
            // 发送邮件
            sendEmail(params){
                const loading = this.$loading({
                    lock: true,
                    text: '发送中',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                api.sendEmail(this.orderId,params).then(()=>{
                    loading.close()
                    this.$message.success({
                        message:'发送成功'
                    })
                    this.closeSendEmailDialog()
                }).catch(()=>{
                    loading.close()
                })
            }

        }


    }
</script>
<style>
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #FF7BAC;
    color: #fff;
  }
  .el-pager li:hover{
    color: #FF7BAC;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #FFF;
  }
</style>

<style scoped>
  .page{
    background-color: #FAFAFA;
    height: 100%;
  }
  .title{
    width: 60%;
    height: 18px;
    /*background-color: #d9d9d9*/
    margin:2% 0 2% 16%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-left{
    width: 10%;
    display: flex;
    justify-content: space-between;
  }
  .no-order{
    width: 60%;
    height: 52%;
    background-color: #F5F6FA;
    margin:0 0 1% 16%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #box{
    width: 60%;
    height: 52%;
    background-color: #FAFAFA;
    margin:0 0 1% 16%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .list-item{
    background-color: #FFFFFF;
    border-radius: 4px;
    height: 25vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 2%;
  }
  .list-item-title{
    width: 96%;
    height: 20%;
    display: flex;
    justify-content: space-between;
    padding: 0 2% 0 2%;
    align-items: center;
    border-bottom: 1px solid #D8D8D8;
  }
  .list-item-title-left{
    width: 280px;
    display: flex;
    justify-content: space-between;
  }
  .list-item-content{
    width: 96%;
    height: 80%;
    display: flex;
    padding: 0 2% 0 2%;
    align-items: center;
  }

  .elc-photo{
    width: 10%;
    height: 70%;
    background-size: 100% 100%;
  }

  .print-photo{
    width: 21%;
    height: 70%;
    background-size: 100% 100%;
    margin: 0 3% 0 1%;
  }

  .list-item-content-contain{
    width: 65%;
    height: 70%;
    padding-top: 10px;
    flex-direction: column;
    display: flex;
    justify-content: space-between;
  }

  .list-item-content-txt{
    width: 95%;
    display: flex;
    justify-content: space-between;
  }
  .list-item-content-txt-item{
    display: flex;

  }

  .list-item-content-btn-contain{
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .list-item-content-btn{
    width: 95px;
    height: 30px;
    border-radius: 15px;
    background-color: #4B00A4;
    color: #F5F6FA;
    font-size: 12px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    margin-left:2% ;

  }

  .pay-flag-cube{
    color: rgba(53,49,92,0.5);
    border: 1px solid rgba(53,49,92,0.5);
    font-size: 12px;
    line-height: 18px;
    padding: 0 3px;
    border-radius: 2px;
  }
  .pay-flag-cube-active{
    color: #FF7BAC;
    border: 1px solid #FF7BAC;
    font-size: 12px;
    line-height: 18px;
    padding: 0 3px;
    border-radius: 2px;
  }
  .trapezoid{
    width:10px;
    height:10px;
    background-color:rgba(0,0,0,0);
    border-top:4px solid rgba(0,0,0,0);
    border-right:4px solid rgba(0,0,0,0);
    border-bottom:4px solid rgba(0,0,0,0);
    border-left:4px solid #FF7BAC;
  }
  #pagination{
    width: 60%;

    margin:0 0 1% 16%;
    display: flex;
    justify-content: center;
  }
  .btn{
    width: 15%;
    height: 40px;
    border-radius: 20px;
    background-color: #4B00A4;
    font-size: 14px;
    color: white;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
</style>
